// extracted by mini-css-extract-plugin
module.exports = {"form__control":"input_form__control__jAPEs","input":"input_input__PE2yu"};